import $ from "jquery";

import utils from "../helpers/utils";

function init(): void {
  if ($(".js-concertina").length) {
    const concertinaId = utils.getUrlParameter("concertinaId");
    const $concertinaToOpen = $(`.js-concertina #${concertinaId}`);

    // Store a clicked concertina id in the URL
    $(".js-concertina .concertina__trigger").click(function () {
      const params = { concertinaId: this.getAttribute("id") };
      window.history.pushState(params, "Current concertina state", "?" + utils.serializeParams(params));
      return false;
    });

    // On page load, open a concertina if provided in the URL
    window.addEventListener("load", () => {
      if (concertinaId && $concertinaToOpen.length) {
        const $concertinaTargetLink = $concertinaToOpen[0];
        const expanded = $concertinaTargetLink.getAttribute("aria-expanded") ?? "false";
        const isOpen = utils.convertToBoolean(expanded);
        const headH = utils.isMobile() ? 0 : $(".js-header").outerHeight() + 80;
        $("html, body").animate({ scrollTop: $concertinaToOpen.offset().top - headH }, 500);
        setTimeout(() => {
          if (!isOpen) {
            $concertinaTargetLink.click();
          }
        });
      }
    });
  }
}

export default { init };
